import { css } from '@emotion/core';
import { variables, tokens, shadow } from '@domain-group/fe-brary';
var global = variables.global;
var colors = tokens.colors,
  shadows = tokens.shadows;
var _ref = {
  name: "1jwyjvh",
  styles: "left:-26px;"
};
var _ref2 = {
  name: "1mzmkfh",
  styles: "right:-25px;"
};
export var popout = _ref6 => {
  var align = _ref6.align;
  return /*#__PURE__*/css("position:relative;top:12px;min-width:200px;border-radius:3px;border:1px solid ", colors.neutral.trim.default, ";background-color:", colors.neutral.surface.default, ";box-shadow:", shadow(shadows.elevation4), ";z-index:", global.layerPopout, ";", align === 'left' && _ref, " ", align === 'right' && _ref2);
};
var arrowStyles = {
  name: "nnqpbd",
  styles: "width:0;height:0;border-right:13px solid transparent;border-bottom:10px solid transparent;border-left:13px solid transparent;"
};
var _ref3 = {
  name: "1vaygsk",
  styles: "left:12px;"
};
var _ref4 = {
  name: "t7a3hj",
  styles: "left:50%;transform:translateX(-50%);"
};
var _ref5 = {
  name: "1uxox82",
  styles: "left:auto;right:12px;"
};
export var arrowOuter = _ref7 => {
  var align = _ref7.align;
  return /*#__PURE__*/css(arrowStyles, " position:absolute;top:-11px;margin:0 auto;border-bottom-color:", colors.neutral.trim.default, ";", align === 'left' && _ref3, " ", align === 'centre' && _ref4, " ", align === 'right' && _ref5);
};
export var arrowInner = /*#__PURE__*/css(arrowStyles, " position:absolute;top:1px;border-bottom-color:", colors.neutral.surface.default, ";left:-13px;");